export default import.meta.ROLLUP_FILE_URL_hmTid491cyggFYxtMSiufg